"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCrc_misc = void 0;
var crokinoleDefs_sidecar_1 = require("@crokinole/main/crokinoleDefs-sidecar");
var physics_rapier_loader_sidecar_1 = require("@crokinole/physics/physics_rapier_loader-sidecar");
var easyCrc_sidecar_1 = require("@dive/to-engine/easyCrc-sidecar");
var namespace = 'crokinole-crc-misc';
function getCrc_misc() {
    var _a = easyCrc_sidecar_1.easyCrc.create(namespace), add = _a.add, addVec2 = _a.addVec2, getCrc = _a.getCrc;
    add(1); // Testing
    add(physics_rapier_loader_sidecar_1.physics_rapier_loader.get().physicsStepsSimulatedCount);
    // TODO: add general game state?
    if (crokinoleDefs_sidecar_1.crokinoleDefs.debug_crcs) {
        console.log(namespace, 'physicsStepsSimulatedCount', physics_rapier_loader_sidecar_1.physics_rapier_loader.get().physicsStepsSimulatedCount);
        console.log(namespace, 'getCrc', getCrc());
    }
    return getCrc();
}
exports.getCrc_misc = getCrc_misc;
